import { getChiJobsList, getChiOpsJobStatus, downloadChiJobResult } from '../../Http/Index';

export interface ChiJob {
  jobId: string;
  companyId: string;
  status: string;
  total: number;
  completed: number;
  failed: number;
  pending: number;
  percentage: number;
  canDownload: boolean;
  createdAt: string;
}

export interface ChiJobStatus {
  jobId: string;
  status: string;
  total: number;
  completed: number;
  failed: number;
  pending: number;
  percentage: number;
  canDownload: boolean;
}

export interface JobListMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export async function fetchChiJobs(
  page: number,
  limit: number,
  companyId?: string,
): Promise<{ jobs: ChiJob[]; meta: JobListMeta }> {
  const res = await getChiJobsList(page, limit, companyId || undefined);
  return {
    jobs: res?.data?.data ?? [],
    meta: res?.data?.meta ?? { total: 0, page, limit, totalPages: 1 },
  };
}

export async function fetchChiJobStatus(jobId: string): Promise<ChiJobStatus> {
  const res = await getChiOpsJobStatus(jobId);
  return res?.data;
}

export async function downloadChiJob(jobId: string): Promise<void> {
  const res = await downloadChiJobResult(jobId);
  const url = window.URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
  a.download = `CHI_care_data_${timestamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
